import { createAction } from 'redux-act';
import { INotification } from 'modules/reducers';
export const fetchNotification = createAction('Fetch Notification');
export const fetchNewNotificationSuccess = createAction<INotification>('Fetch Notification');
export const fetchNotificationSuccess = createAction<INotification[]>('Fetch Notification success');
export const setPrivateMsgNotification = createAction<any>('Piravte Msg Notification');
